export const getFileExtension = (
  file: File | null
): string | null | undefined => {
  if (!file) return null;

  // Try MIME type first
  if (file.type) {
    switch (file.type) {
      case "application/vnd.ms-excel":
        return "csv";
      case "text/csv":
        return "csv";
      case "application/json":
        return "json";
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return "xlsx";
    }
  }

  // Fallback to extension
  return file.name.split(".").pop()?.toLowerCase();
};
